import { computed } from 'vue'
import { DateTime } from 'luxon'
import { useNow } from '@/composables/game/time'
import { env } from '@/env'

/** Boinkers campaign mini app, opened from the home screen bottom buttons. */
export const BOINKERS_LINK = 'https://t.me/boinker_bot/boinkapp?startapp=p_r_mDropeeM2026campDropeeM2026'

/** The campaign starts at 16:00 Paris time on 2026-09-18. */
const BOINKERS_START_TIMESTAMP = DateTime.fromISO('2026-09-18T16:00', { zone: 'Europe/Paris' }).toUnixInteger()

export const useBoinkers = () => {
  const { now } = useNow()

  // Always visible outside prod so the button can be previewed before the campaign starts.
  const showBoinkers = computed(() => !env.app.isProd || now.value >= BOINKERS_START_TIMESTAMP)

  return {
    showBoinkers,
  }
}
